import { TransitTime } from "@/models/admin/TransitTime";
import { TransitTimeStat } from "@/models/admin/TransitTimeStat";
import ServiceBase from "@/services/ServiceBase";

class TransitTimeService extends ServiceBase {
  search(origZip: string, destZip: string, pickupDate: string): Promise<TransitTime[]> {
    return this.post<TransitTime[]>("/api/transit-time/search", {
      origZip: origZip,
      destZip: destZip,
      pickupDate: pickupDate
    }, null);
  }

  getStatsByAccountId(accountId: string, days: number): Promise<TransitTimeStat[]> {
    return this.get<TransitTimeStat[]>(`/api/transit-time/stats?accountId=${accountId}&days=${days}`);
  }
}

export default new TransitTimeService();